/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetUserToursResponseDto } from '../models';
// @ts-ignore
import type { SaveDoneUserToursRequestDto } from '../models';
/**
 * UserToursRestApi - axios parameter creator
 */
export const UserToursRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get list off user tours
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTours: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserTours', 'userId', userId)
            const localVarPath = `/api/v1/users/{userId}/tours`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of user done tours
         * @param {string} userId 
         * @param {SaveDoneUserToursRequestDto} saveDoneUserToursRequestDto List of user done tours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDoneTours: async (userId: string, saveDoneUserToursRequestDto: SaveDoneUserToursRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('saveDoneTours', 'userId', userId)
            // verify required parameter 'saveDoneUserToursRequestDto' is not null or undefined
            assertParamExists('saveDoneTours', 'saveDoneUserToursRequestDto', saveDoneUserToursRequestDto)
            const localVarPath = `/api/v1/users/{userId}/tours`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDoneUserToursRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserToursRestApi - functional programming interface
 */
export const UserToursRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserToursRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get list off user tours
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTours(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserToursResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTours(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserToursRestApi.getUserTours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List of user done tours
         * @param {string} userId 
         * @param {SaveDoneUserToursRequestDto} saveDoneUserToursRequestDto List of user done tours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDoneTours(userId: string, saveDoneUserToursRequestDto: SaveDoneUserToursRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDoneTours(userId, saveDoneUserToursRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserToursRestApi.saveDoneTours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserToursRestApi - factory interface
 */
export const UserToursRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserToursRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Get list off user tours
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTours(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserToursResponseDto> {
            return localVarFp.getUserTours(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of user done tours
         * @param {string} userId 
         * @param {SaveDoneUserToursRequestDto} saveDoneUserToursRequestDto List of user done tours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDoneTours(userId: string, saveDoneUserToursRequestDto: SaveDoneUserToursRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveDoneTours(userId, saveDoneUserToursRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserToursRestApi - interface
 */
export interface UserToursRestApiInterface {
    /**
     * 
     * @summary Get list off user tours
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserTours(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetUserToursResponseDto>;

    /**
     * 
     * @summary List of user done tours
     * @param {string} userId 
     * @param {SaveDoneUserToursRequestDto} saveDoneUserToursRequestDto List of user done tours
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveDoneTours(userId: string, saveDoneUserToursRequestDto: SaveDoneUserToursRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * UserToursRestApi - object-oriented interface
 */
export class UserToursRestApi extends BaseAPI implements UserToursRestApiInterface {
    /**
     * 
     * @summary Get list off user tours
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserTours(userId: string, options?: RawAxiosRequestConfig) {
        return UserToursRestApiFp(this.configuration).getUserTours(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of user done tours
     * @param {string} userId 
     * @param {SaveDoneUserToursRequestDto} saveDoneUserToursRequestDto List of user done tours
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveDoneTours(userId: string, saveDoneUserToursRequestDto: SaveDoneUserToursRequestDto, options?: RawAxiosRequestConfig) {
        return UserToursRestApiFp(this.configuration).saveDoneTours(userId, saveDoneUserToursRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

